/* RŌZ Looks — gallery lightbox. Direct port of roz-looks-demo's
   LookGallery.astro inline script (vanilla, no framework). One shared
   <dialog> per gallery; arrows walk the examples of the variant that was
   tapped — never across into the next variant's grid. */
(function () {
  var gallery = document.querySelector('[data-look-gallery]');
  var dialog = gallery && gallery.querySelector('[data-look-dialog]');
  if (!gallery || !dialog || typeof dialog.showModal !== 'function') return;

  var media = dialog.querySelector('[data-look-dialog-media]');
  var image;
  var lookName = dialog.querySelector('[data-look-dialog-lookname]');
  var stylist = dialog.querySelector('[data-look-dialog-stylist]');
  var position = dialog.querySelector('[data-look-dialog-position]');
  var nav = dialog.querySelector('[data-look-dialog-nav]');
  var credit = dialog.querySelector('[data-look-dialog-credit]');
  var locRow = dialog.querySelector('[data-look-dialog-loc-row]');
  var loc = dialog.querySelector('[data-look-dialog-loc]');
  var book = dialog.querySelector('[data-look-book]');
  var ig = dialog.querySelector('[data-look-ig]');
  var post = dialog.querySelector('[data-look-dialog-post]');
  var ph = dialog.querySelector('[data-look-dialog-ph]');

  var siblings = [];
  var active = 0;

  function show(index) {
    var trigger = siblings[index];
    if (!trigger) return;
    active = index;
    var d = trigger.dataset;

    if (d.image) {
      if (!image) {
        image = document.createElement('img');
        image.setAttribute('data-look-dialog-image', '');
        if (media) media.appendChild(image);
      }
      image.src = d.image;
      image.alt = d.alt || '';
    }
    /* License-driven watermark mirrors the tapped tile's state. */
    if (ph) ph.hidden = d.licensed === '1';
    if (lookName) lookName.textContent = d.name || '';
    /* The stylist is the headline of the card; the handle links to Instagram. */
    if (stylist) stylist.textContent = d.stylist || d.handle || '';
    if (credit) {
      credit.textContent = d.handle || '';
      credit.href = d.profile || '#';
    }
    if (locRow && loc) {
      /* When the account IS the salon, the headline already names it — the
         location row then carries just the city. */
      var headline = d.stylist || d.handle || '';
      var salon = d.salon || '';
      if (salon && salon.toLowerCase() === headline.toLowerCase()) salon = '';
      var place = [salon, d.city].filter(Boolean).join(' · ');
      loc.textContent = place;
      locRow.hidden = !place;
    }
    if (book) {
      book.hidden = !d.booking;
      book.href = d.booking || '#';
      book.textContent = d.bookingLabel || 'Book an appointment';
    }
    if (ig) ig.href = d.profile || '#';
    if (post) {
      post.hidden = !d.post;
      post.href = d.post || '#';
    }
    if (nav) nav.hidden = siblings.length < 2;
    if (position) position.textContent = 'Photo ' + (index + 1) + ' of ' + siblings.length;
  }

  Array.prototype.forEach.call(gallery.querySelectorAll('[data-example-open]'), function (trigger) {
    trigger.addEventListener('click', function () {
      var section = trigger.closest('[data-look-section]');
      siblings = Array.prototype.slice.call(
        (section || gallery).querySelectorAll('[data-example-open]')
      );
      show(siblings.indexOf(trigger));
      if (!dialog.open) {
        dialog.showModal();
        /* The sheet scrolls itself; the page behind it must not. */
        document.body.style.overflow = 'hidden';
      }
    });
  });

  var closeBtn = dialog.querySelector('[data-look-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  /* Clicks land on the dialog element itself only when they hit the backdrop. */
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
  /* Every close path — Esc, backdrop, the button — lands here. */
  dialog.addEventListener('close', function () {
    document.body.style.overflow = '';
  });

  function step(delta) {
    if (siblings.length < 2) return;
    show((active + delta + siblings.length) % siblings.length);
  }

  var prev = dialog.querySelector('[data-look-prev]');
  var next = dialog.querySelector('[data-look-next]');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });

  dialog.addEventListener('keydown', function (event) {
    if (siblings.length < 2) return;
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      step(1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      step(-1);
    }
  });

  /* Horizontal swipe pages the bottom sheet. The axis check keeps a vertical
     scroll from paging the examples. */
  var touchX = 0;
  var touchY = 0;
  dialog.addEventListener('touchstart', function (event) {
    touchX = event.changedTouches[0].clientX;
    touchY = event.changedTouches[0].clientY;
  }, { passive: true });
  dialog.addEventListener('touchend', function (event) {
    var dx = event.changedTouches[0].clientX - touchX;
    var dy = event.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
